@if (apiloaded) {
  <div class="row col-12 col-sm-12 my-account-container" [ngClass]="isMobile? 'px-0':'pr-0'">
    @if (!isMobile) {
      <div class="col-3 col-sm-3 my-account-left-nav">
        <app-my-account-left-sidenav [navState]="'SupportTicketNavNode'"></app-my-account-left-sidenav>
      </div>
    }
    <div
      [ngClass]="isMobile? 'col-12 my-ticket-right-section' :'col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav'">
      <h1 class="myProfileTopHeader m-0">{{'common.text_customer360_activity_tickets'|cxTranslate}}
      </h1>
      <div class="myProfileBody my-ticket-section">
        <div class="btndiv">
          <div class="btndiv_inner">
            <a routerLink="/add-support-ticket"
              class="btn fs-20 btn-primary btn-block btn-blue">{{'common.text_account_supporttickets_requestSupport'|cxTranslate}}
            </a>
          </div>
        </div>
        <form [formGroup]="ticketForm" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
          <div class="customerIdContainer">
            <div class="container-cus-block">
              <div class="acc-sec-content">
                <div class="customer-block-title camelCase">
                {{'common.text_account_supporttickets_customerID'|cxTranslate}}</div>
                <div class="select">
                  <select name="customer" class="select-customer" id="customerId"
                    formControlName="defaultSoldTo">
                    @for (opt of myTicket?.b2bUnitsWSList; track opt) {
                      <option [value]="opt?.uid"
                        [disabled]="opt?.orderBlocked"
                        [selected]="$any(myTicket)?.defaultSoldTo == opt?.uid"
                        [ngClass]="opt?.orderBlocked ? 'bgGrey':''">
                        @if (opt?.salesArea1) {
                          <span> {{ opt?.salesArea1}}&nbsp;|&nbsp;</span>
                        }
                        @if (opt?.salesArea2) {
                          <span
                          >{{opt?.salesArea2|cxTranslate}}&nbsp;|&nbsp;</span>
                        }
                        @if (opt?.salesArea3) {
                          <span> {{opt?.salesArea3 }}</span>
                        }
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="dateStausSection my-ticket-block">
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="titleCode"
              class="control-label">{{'common.text_headline_status'|cxTranslate}}</label>
              <div class="select-box">
                <select name="titleCode" class="form-control selecter" formControlName="status">
                  <option value="null" [selected]="tickForm.status.invalid" disabled>
                    {{'common.text_account_supporttickets_statusList'|cxTranslate}}
                  </option>
                  @for (item of myTicket?.status; track item; let i = $index) {
                    <option class="camelCase"
                      [value]="item.code">
                      @if (item?.code.toLowerCase() == 'new') {
                        {{'common.text_account_supporttickets_createTicket_status_OPEN'|cxTranslate}}
                      }
                      @if (item?.code.toLowerCase() == 'open') {
                        {{'common.text_account_supporttickets_createTicket_status_INPROGRESS'|cxTranslate}}
                      }
                      @if (item?.code.toLowerCase() == 'customeraction') {
                        {{'common.text_account_supporttickets_createTicket_status_CUSTOMERACTION'|cxTranslate}}
                      }
                      @if (item?.code.toLowerCase() == 'completed') {
                        {{'common.text_account_supporttickets_createTicket_status_COMPLETED'|cxTranslate}}
                      }
                      @if (item?.code.toLowerCase() == 'closed') {
                        {{'common.text_account_supporttickets_createTicket_status_CLOSED'|cxTranslate}}
                      }
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="my-ticket-date-block">
              <div class="col-xs-12 col-12 col-sm-12 col-md-12 col-lg-6 form-group mb-3 align-self-end my-ticket-left-calender"
                [class.px-0]="isMobile">
                <div class="form-group">
                  <label for="startDate">
                    {{'common.text_supporttickets_search_from_date'|cxTranslate}}*
                  </label>
                  <input class="form-control bsdpicker kb-datePickerIcon" placeholder="Datepicker"
                    bsDatepicker formControlName="startDateString" [maxDate]="today"
                    [bsConfig]="{ dateInputFormat: bsConfigFormat, showWeekNumbers:false, displayOneMonthRange: true }">
                  </div>
                </div>
                <div class="col-xs-12 col-12 col-sm-12 col-md-12 col-lg-6 form-group mb-3 align-self-end">
                  <div class="form-group">
                    <label for="enddate">
                      {{'common.text_supporttickets_search_to_date'|cxTranslate}}*
                    </label>
                    <input class="form-control bsdpicker kb-datePickerIcon" placeholder="Datepicker"
                      bsDatepicker formControlName="endDateString" [maxDate]="today"
                      [bsConfig]="{ dateInputFormat: bsConfigFormat,showWeekNumbers:false, displayOneMonthRange: true }">
                    </div>
                  </div>
                </div>
              </div>
              <div class="myProfileButtonContainer mt-2 row">
                <div
                  [ngClass]="isMobile ? 'd-flex flex-column my-ticket-btn-block': 'd-flex ml-auto search-btn-block'">
                  <button class=" btn btn-primary btn-blue fs-20 px-4" type="button" (click)="reset()"
                  [ngClass]="isMobile ? 'mb-3':''">{{'common.text_supporttickets_reset'|cxTranslate}}</button>
                  <button class=" btn btn-primary-new fs-20" [ngClass]="isMobile ? '': 'ml-3'"
                    type="submit">{{'common.text_supporttickets_search'|cxTranslate}}<img
                  src="/icons/link-grey.svg" style="width: 20px;"></button>
                </div>
              </div>
            </form>
            @if ( userList?.ticketsList && userList?.ticketsList.length==0) {
              <div class="py-5 noTickets">
                <b>{{'common.text_account_supporttickets_noSupporttickets'|cxTranslate}}</b>
              </div>
            }
          </div>
          @if ( userList?.ticketsList && userList?.ticketsList.length==0) {
            <div class="gray-search-result-box">
              {{grayTotalticketsValue}}
            </div>
          }
          <!-- here the content goes for table to display the tickets -->
          @if ( userList?.ticketsList && userList?.ticketsList.length>0) {
            <div [class.sort-section]="isMobile">
              <div class="gray-search-result-box">
                {{grayTotalticketsValue}}
              </div>
              <div class="account-overview-table mycompany-manageUser">
                <table class="responsive-table table table-bordered table-blue my-ticet-search-table">
                  <thead>
                    <tr class="responsive-table-head hidden-xs hidden-sm">
                      <th scope="col">{{'common.text_account_supporttickets_ticketType'|cxTranslate}}</th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('ticketId')">
                          <span>{{'common.text_account_supporttickets_ticketId'|cxTranslate}}
                            @if (sortByTicketId == 'asc') {
                              &#8593;
                            }
                            @if (sortByTicketId == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('category')">
                          <span>{{'common.text_account_supporttickets_category'|cxTranslate}}
                            @if (sortByCategory == 'asc') {
                              &#8593;
                            }
                            @if (sortByCategory == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('headline')">
                          <span>{{'common.text_account_supporttickets_subject'|cxTranslate}}
                            @if (sortBySubject == 'asc') {
                              &#8593;
                            }
                            @if (sortBySubject == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('modifiedtime')">
                          <span>{{'common.text_account_supporttickets_dateCreated'|cxTranslate}}
                            @if (sortByDateCreated == 'asc') {
                              &#8593;
                            }
                            @if (sortByDateCreated == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('modifiedtime')">
                          <span>{{'common.text_account_supporttickets_dateUpdated'|cxTranslate}}
                            @if (sortByDateUpdated == 'asc') {
                              &#8593;
                            }
                            @if (sortByDateUpdated == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('state')">
                          <span>{{'common.text_account_supporttickets_status'|cxTranslate}}
                            @if (sortByStatus == 'asc') {
                              &#8593;
                            }
                            @if (sortByStatus == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                    </tr>
                  </thead>
                  @if (userList) {
                    <tbody>
                      @for (item of userList?.ticketsList; track item) {
                        <tr class="responsive-table-item">
                          <td class="responsive-table-cell">
                            <a [routerLink]="['/update-support-ticket']"
                              [queryParams]="{id:item.ticketID,code:item.ticketType.code}">
                              <span
                              class="d-lg-none my-ticket-table-label">{{'common.text_account_supporttickets_ticketType'|cxTranslate}}</span>
                              <span class="mycompnay-registration-value pointer">
                                @if (item.ticketType.code == 'WEB') {
                                  {{'common.text_account_supporttickets_createTicket_tickettype_WEB'|cxTranslate}}
                                } @else {
                                  {{'common.text_account_supporttickets_createTicket_tickettype_MANUAL'|cxTranslate}}
                                }
                              </span></a>
                            </td>
                            <td class="responsive-table-cell">
                              <a [routerLink]="['/update-support-ticket']"
                                [queryParams]="{id:item.ticketID,code:item.ticketType.code}">
                                <span
                                class="d-lg-none my-ticket-table-label">{{'common.text_account_supporttickets_ticketId'|cxTranslate}}</span>
                                <span class="mycompnay-registration-value pointer">{{item.ticketID}}</span></a>
                              </td>
                              <td class="responsive-table-cell">
                                <a [routerLink]="['/update-support-ticket']"
                                  [queryParams]="{id:item.ticketID,code:item.ticketType.code}">
                                  <span class="mycompnay-registration-value pointer">
                                    @if (item.kbecomTicketCategory.code == 'PSA') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_PSA'|cxTranslate}}
                                    }
                                    @if (item.kbecomTicketCategory.code == 'PSG') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_PSG'|cxTranslate}}
                                    }
                                    @if (item.kbecomTicketCategory.code == 'TST') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_TST'|cxTranslate}}
                                    }
                                    @if (item.kbecomTicketCategory.code == 'Order') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_ORDER'|cxTranslate}}
                                    }
                                    @if (item.kbecomTicketCategory.code == 'Warranty') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_WARRANTY'|cxTranslate}}
                                    }
                                    @if (item.kbecomTicketCategory.code == 'Core') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_CORE'|cxTranslate}}
                                    }
                                    @if (item.kbecomTicketCategory.code == 'OTH') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_OTH'|cxTranslate}}
                                    }
                                    @if (item.kbecomTicketCategory.code == 'other') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_SOTHER'|cxTranslate}}
                                    }
                                  </span></a>
                                </td>
                                <td class="responsive-table-cell">
                                  <a (click)="editUser(item.ticketID,item.ticketType.code)">
                                    <span
                                    class="d-lg-none my-ticket-table-label">{{'common.text_account_supporttickets_subject'|cxTranslate}}</span>
                                    <span class="mycompnay-registration-value pointer">{{item.subject}}</span>
                                  </a>
                                </td>
                                <td class="responsive-table-cell">
                                  <span
                                  class="d-lg-none my-ticket-table-label">{{'common.text_account_supporttickets_dateCreated'|cxTranslate}}</span>
                                  <span class="mycompnay-registration-value">
                                    <span>{{item?.creationDate | date:'dd/MM/yyyy'}}</span>
                                  </span>
                                </td>
                                <td class="responsive-table-cell">
                                  <span
                                  class="d-lg-none my-ticket-table-label">{{'common.text_account_supporttickets_dateUpdated'|cxTranslate}}</span>
                                  <span class="mycompnay-registration-value">
                                    <span>{{item?.lastModificationDate2 | date:'dd/MM/yyyy hh:mm'}}</span>
                                  </span>
                                </td>
                                <td class="responsive-table-cell">
                                  <span class="mycompnay-registration-value">
                                    @if (item.status?.id?.toUpperCase() == 'ENQUIRY') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_ENQUIRY'|cxTranslate}}
                                    }
                                    @if (item.status?.id?.toUpperCase() == 'COMPLAINT') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_COMPLAINT'|cxTranslate}}
                                    }
                                    @if (item.status?.id?.toUpperCase() == 'PROBLEM') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_PROBLEM'|cxTranslate}}
                                    }
                                    @if (item.status?.id?.toUpperCase() == 'NEW') {
                                      {{'common.text_account_supporttickets_createTicket_status_NEW'|cxTranslate}}
                                    }
                                    @if (item.status?.id?.toUpperCase() == 'OPEN') {
                                      {{'common.text_account_supporttickets_createTicket_status_OPEN'|cxTranslate}}
                                    }
                                    @if (item.status?.id?.toUpperCase() == 'Core') {
                                      {{'common.text_account_supporttickets_createTicket_ticketCategory_CORE'|cxTranslate}}
                                    }
                                    @if (item.status?.id?.toUpperCase() == 'INPROGRESS') {
                                      {{'common.text_account_supporttickets_createTicket_status_INPROGRESS'|cxTranslate}}
                                    }
                                    @if (item.status?.id?.toUpperCase() == 'CUSTOMERACTION') {
                                      {{'common.text_account_supporttickets_createTicket_status_CUSTOMERACTION'|cxTranslate}}
                                    }
                                    @if (item.status?.id?.toUpperCase() == 'COMPLETED') {
                                      {{'common.text_account_supporttickets_createTicket_status_COMPLETED'|cxTranslate}}
                                    }
                                    @if (item.status?.id?.toUpperCase()== 'CLOSED') {
                                      {{'common.text_account_supporttickets_createTicket_status_CLOSED'|cxTranslate}}
                                    }
                                  </span>
                                </td>
                              </tr>
                            }
                          </tbody>
                        }
                      </table>
                    </div>
                    <div class="account-orderhistory-pagination company-users-pagination">
                      <div class="product__list--wrapper py-2">
                        <div class="pagination-bar">
                          <div class="pagination-toolbar">
                            <div class="row sort-refine-bar">
                              <div class="col-xs-12 col-sm-6 col-md-6 bottom-result">
                                <div class="pagination-result">
                                  <label>{{paginationBarValue}}</label>
                                </div>
                              </div>
                              <div class="col-xs-12 col-sm-6 col-md-6 kb-pagination-right kb-pagination d-flex justify-content-center justify-content-lg-end me-1"
                                [ngClass]="isMobile? 'mb-3': ''">
                                <kb-pagination [pagination]="$any(userList)?.pagination" [defaultPage]="0"
                                (viewPageEvent)="changePageCustom($event, $any(userList)?.searchPageData)"></kb-pagination>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }